// extracted by mini-css-extract-plugin
export default {"form":"VolumeForm_form__a7Gmi","input":"VolumeForm_input__O-uUl","submit_button":"VolumeForm_submit_button__Mz8gY"};